import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface RemoteClient {
  id: string;
  name: string;
  group?: string;
  rustdeskId: string;
  pin?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
  isEditing?: boolean;
}

export interface DialogData {
  client: RemoteClient | null;
  mode: 'create' | 'update';
}

@Component({
  selector: 'app-remote-client-dialog',
  templateUrl: 'remote-client-dialog.component.html',
  styleUrls: ['./remote-client-dialog.component.scss']
})
export class RemoteClientDialogComponent {

  client: RemoteClient;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<RemoteClientDialogComponent>) {

    if (data.mode === 'update' && data.client) {
      this.client = { ...data.client };
    } else {
      this.client = {
        id: '',
        name: '',
        group: '',
        rustdeskId: '',
        pin: '',
        contactName: '',
        contactPhone: '',
        contactEmail: ''
      };
    }
  }

  onSave(): void {
    this.dialogRef.close(this.client);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}